import styled from 'styled-components';
import { Box, Button } from '@rsos/base-components';
import StyledSmartLink from '@rsos/components/capstone/Layout/Navigation/common/StyledSmartLink';
import EventPaneBanner from '../../../EventPaneBanner';

export const CustomModalHeader = styled(Box).attrs({
  bg: 'primaryBase',
  p: 0,
  justify: 'space-between',
  align: 'flex-start',
  mb: 0,
  position: 'relative',
})``;

export const HeaderContent = styled(Box)`
  padding: 20px;
  flex: 1;
`;

export const CloseButton = styled(Button).attrs({
  btnType: 'invisible',
})`
  position: absolute;
  top: 15px;
  right: 15px;
  color: ${({ theme }) => theme.colors.background};
  padding: 5px;
  min-width: auto;
  height: auto;

  &:hover {
    background: rgba(255, 255, 255, 0.1);
  }
`;

export const TightStyledSmartLink = styled(StyledSmartLink)`
  padding: 0;
`;
